import * as React from 'react';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import { usePrivateSteppingContext } from '../../Context/PrivateSteppingContext.js';
import { ConfiguratorHeader } from './ConfiguratorHeader.js';
import { getStepWizardData } from './selectors.internal.js';

const ConfiguratorHeaderContainer = ()=>{
    const { getLabel  } = useIntl();
    const { selectorProps  } = usePrivateSteppingContext();
    const { enabledStepLabels , currentStepIndex , disableSteps , skipSteps  } = useSelector((s)=>getStepWizardData(s, selectorProps)
    );
    if (!isDefined(currentStepIndex)) {
        throw new Error(`Need current step index to render configurator header. Received: "${currentStepIndex}".`);
    }
    return /*#__PURE__*/ React.createElement(ConfiguratorHeader, {
        stepNameLabels: enabledStepLabels.map((l)=>getLabel(l)
        ),
        currentStepIndex: currentStepIndex,
        disableSteps: disableSteps,
        skipSteps: skipSteps
    });
};

export { ConfiguratorHeaderContainer };
//# sourceMappingURL=ConfiguratorHeaderContainer.js.map
